import { ExportIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import type { ActionMenuItem } from '@/components';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { useSourcesStore } from '@/stores';
import type { Event } from '@/types/event';
import { exportableEvent } from '@/utils/export';
import type { EventsExportControls } from './useEventsExport';

export function useExportEventMenuItem() {
    const { t } = useTranslation(I18nNamespace.EVENTS);
    const getSourceById = useSourcesStore((state) => state.getSourceById);

    return (
        event: Event,
        eventExport: EventsExportControls,
    ): ActionMenuItem[] => {
        if (!exportableEvent(event, getSourceById(event.sourceId))) {
            return [];
        }
        return [
            {
                key: 'export',
                label: t('actions.export'),
                icon: ExportIcon,
                disabled: eventExport.busy,
                onSelect: () => void eventExport.startExport([event.id]),
            },
        ];
    };
}
